// extracted by mini-css-extract-plugin
export default {"root":"vdBKT","color-green":"_1t9pM","colorGreen":"_1t9pM","color-red":"_185eq","colorRed":"_185eq"};